export default __webpack_public_path__ + "static/media/eIcon6.0c9acc43.svg";